import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  colors,
  fontSizes,
  radii,
} from "@softmax/design-system/tokens.stylex";
import type { EpisodeLinks } from "./episode-values";

export function EpisodeActions({ row }: { readonly row: EpisodeLinks }) {
  return (
    <span {...stylex.props(localStyles.actions)}>
      {row.replayHref ? (
        <a
          href={row.replayHref}
          target="_blank"
          rel="noreferrer"
          {...stylex.props(localStyles.action)}
        >
          Replay
        </a>
      ) : null}
      <a href={row.episodeHref} {...stylex.props(localStyles.action)}>
        Details
      </a>
    </span>
  );
}

const localStyles = stylex.create({
  actions: { display: "flex", alignItems: "center", gap: 6 },
  action: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: { default: 28, "@media (pointer: coarse)": 44 },
    paddingInline: spacing.space10,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
    borderRadius: radii.small,
    color: colors.foreground,
    fontSize: fontSizes.caption,
    fontWeight: 500,
    textDecoration: "none",
    backgroundColor: { default: "transparent", ":hover": colors.surfaceAlt },
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 2,
  },
});
